// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/style.scss
// module id = 1073
// module chunks = 65